import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';
import { FaShoppingBag, FaBars, FaTimes } from 'react-icons/fa';
import { useCart } from '../contexts/CartContext';

const Header = () => {
  const location = useLocation();
  const { getItemCount } = useCart();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isHomePage = location.pathname === '/';

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <nav className="nav">
        <div className="logo-container">
          <Link to="/" onClick={closeMenu}>
            <img src={logo} alt="Fire House Spirits Logo" className="logo" />
          </Link>
        </div>
        <ul className="nav-links">
          <li>
            {isHomePage ? (
              <a href="/">House</a>
            ) : (
              <Link to="/">House</Link>
            )}
          </li>
          <li>
            {isHomePage ? (
              <a href="/shop">Store</a>
            ) : (
              <Link to="/shop">Store</Link>
            )}
          </li>
          <li>
            <Link to="/about">About Us</Link>
          </li>
          <li><a href="/contact">Contact</a></li>
          <li><Link to="/stories">Stories</Link></li>
          <li>
            <Link to="/cart" className="cart-link">
              <FaShoppingBag />
              {getItemCount() > 0 && (
                <span className="cart-count">{getItemCount()}</span>
              )}
            </Link>
          </li>
        </ul>
        <ul className={`nav-links-mobile ${isMenuOpen ? 'open' : ''}`}>
            <li>
            {isHomePage ? (
              <a href="/" onClick={closeMenu}>House</a>
            ) : (
              <Link to="/" onClick={closeMenu}>House</Link>
            )}
          </li>
          <li>
            {isHomePage ? (
              <a href="/shop" onClick={closeMenu}>Store</a>
            ) : (
              <Link to="/shop" onClick={closeMenu}>Store</Link>
            )}
          </li>
          <li>
            <Link to="/about" onClick={closeMenu}>About Us</Link>
          </li>
          <li><a href="/contact" onClick={closeMenu}>Contact</a></li>
          <li><Link to="/stories" onClick={closeMenu}>Stories</Link></li>
          <li>
            <Link to="/cart" className="cart-link" onClick={closeMenu}>
              <FaShoppingBag />
              {getItemCount() > 0 && (
                <span className="cart-count">{getItemCount()}</span>
              )}
            </Link>
          </li>
        </ul>
        <button className="hamburger" onClick={toggleMenu} aria-label="Toggle menu">
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </nav>
    </header>
  );
};

export default Header;
